module.exports = __webpack_public_path__ + "img/harrys_prophecy.9d8c744c.jpg";